<template>
  <div class="landing-page">
    <div class="content">
      <h1>{{ title }}</h1>

      <p class="ingress">
        Slipp allt krångel med blanketter och jobbiga skrivare. Sköt din
        överlåtelse direkt i vår tjänst.
      </p>
      <LoginInfoText :support-address="getSupportAddress" />
      <CollapseCard
        v-if="isPrivateFlow && landlord?.ovPrivateDisclaimer"
        :is-alert="true"
        class="mb-2"
      >
        <template slot="body-text">
          <p style="display: flex; gap: 2rem">
            <BaseImage class="icon-tip" :url="svgs.ICONS.TIP_DARK" />{{
              landlord.ovPrivateDisclaimer
            }}
          </p>
        </template>
      </CollapseCard>
      <BankidLogin @initiate="$emit('initiate')">
        <template slot="header">Starta ny ansökan / Logga in</template>
      </BankidLogin>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import svgs from '@/utils/icon-constants';

import BankidLogin from '@/components/BankidLogin.vue';
import LoginInfoText from '@/components/LoginInfoText.vue';
import CollapseCard from '@/components/CollapseCard.vue';
import BaseImage from '@/components/BaseImage.vue';

export default {
  components: {
    BankidLogin,
    LoginInfoText,
    CollapseCard,
    BaseImage
  },

  data() {
    return {
      svgs
    };
  },

  computed: {
    ...mapState({
      landlord: state => state.app.landlord
    }),
    ...mapGetters({
      isMobile: 'app/isMobile',
      getSupportAddress: 'app/getSupportAddress',
      isPrivateFlow: 'ovApplication/isPrivateFlow'
    }),
    title() {
      if (!this.isPrivateFlow) {
        return 'Välkommen till Överlåtelser för företagsärenden.';
      }
      return 'Välkommen till Överlåtelser.';
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  text-align: center;
  width: 800px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 2.5rem;
  line-height: 1.6;
  h1 {
    font-size: 3.2rem;
    line-height: 1.2;
    @include mobile {
      font-size: 2.4rem;
    }
  }
  p {
    font-size: 1.6rem;
    margin: 2rem 0;
    line-height: 1.5;
    @include mobile {
      font-size: 1.5rem;
      margin: 1rem 0;
    }
  }
  .ingress {
    font-weight: 600;
  }
  .mail-to {
    color: var(--color-blue);
  }
}
</style>
